module.exports = __webpack_public_path__ + "img/bg.0ad90348.png";